var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Inicio")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/tengoAgua"}},[_vm._v("Presas")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }